export default __webpack_public_path__ + "static/media/devices.d01dbbee.svg";